"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVideoState = useVideoState;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var getVideoPlayer_1 = require("./getVideoPlayer");
function useVideoState() {
    var _a, _b;
    var video = (0, react_redux_1.useSelector)(function (state) {
        return state.video;
    });
    var contentId = (_a = video === null || video === void 0 ? void 0 : video.getIn) === null || _a === void 0 ? void 0 : _a.call(video, ['data', 'id']);
    var featureMediaId = (_b = video === null || video === void 0 ? void 0 : video.getIn) === null || _b === void 0 ? void 0 : _b.call(video, ['data', 'feature', 'id']);
    var getPlaybackState = (0, react_1.useCallback)(function () {
        var player = (0, getVideoPlayer_1.getVideoPlayer)();
        if (!player) {
            return {
                currentTimeSeconds: null,
                isPaused: null,
            };
        }
        try {
            var currentTimeSeconds = typeof player.currentTime === 'function'
                ? player.currentTime()
                : null;
            var isPaused = typeof player.paused === 'function'
                ? player.paused()
                : null;
            return {
                currentTimeSeconds: currentTimeSeconds,
                isPaused: isPaused,
            };
        }
        catch (_a) {
            return {
                currentTimeSeconds: null,
                isPaused: null,
            };
        }
    }, []);
    return {
        contentId: contentId ? String(contentId) : null,
        featureMediaId: featureMediaId ? String(featureMediaId) : null,
        getPlaybackState: getPlaybackState,
    };
}
